import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/evcs_charge_records',
  component: Management,
  redirect: '/evcs_charge_records/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/evcs_charge_records/List'),
      meta: {
        auth: Auth.listEvcsChargeRecords
      },
      redirect: 'list/all',
      children: [
        {
          path: 'all',
          component: () => import('@/views/evcs_charge_records/ListTable'),
          meta: {
            auth: Auth.listEvcsChargeRecords,
            tabName: 'all'
          }
        }
      ]
    }
  ]
}
